import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { BaseLicensePage } from '@components/shared/license/base.license.page';
import { IModalResult } from '@components/ui-modal/ui-modal.component';
import {
    IHostLicense,
    ITenant,
    ModalResultType,
} from '@models';
import { TenantLicenseModalComponent } from '@pages/host/tenants/license/tenant-license.modal';
import { ModalService } from '@services';

import { merge } from 'rxjs';

@Component({
    templateUrl: './host-licenses.page.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class HostLicensePageComponent extends BaseLicensePage<IHostLicense> {

    private _modalService = this._injector.get<ModalService>(ModalService);

    public onRemove(payload: { deactivate: boolean, hostLicenseId?: number }) {
        this._onRemove(payload.deactivate);
    }

    public allocateLicenses() {
        const modalRef = this._modalService
            .openModal(
                TenantLicenseModalComponent,
                null, {
                    data: {
                        readonly: false,
                        closeAfterAllocation: false,
                    },
                    size: 'sm',
                    additionalClasses: ['allocate-license-modal'],
                },
            );

        merge(
            (modalRef as any).customEvent, // TODO: check this
            modalRef.afterClosedResult(),
        )
            .subscribe((res: IModalResult<ITenant> | any) => {
                if (res.type === ModalResultType.Update) {
                    this._cd.detectChanges();
                } else if (res.type === ModalResultType.Failed) {
                    this.openDeactivateOfflineModal(res.additionalData.tenantId);
                }
            });
    }

}
